import Vue from 'vue';

export default {
  error ({msg, timeout = 5000, position = 'toast-top-right', title = Vue.prototype.$messages.TITULO_ERROR}) {
    Vue.prototype.$toastr(Vue.prototype.$messages.TIPO_ERROR,
      {
        title,
        msg,
        clickClose: true,
        timeout,
        position
      }
    )
  },
  confirmBox({body, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', type = 'warning'}) { // eslint-disable-line
    window.setTimeout(() => {
      Vue.prototype.$confirm(body.message, body.title, {
        confirmButtonText,
        cancelButtonText,
        type
      })
        .then(body.callback)
        .catch(body.error)
    }, 100)
  }
}
